export enum EModalState {
  Verification,
  Wallet,
  Request,
}
